import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import ADICreditCardListState from "../Data/ADICreditCardListRecapState";
import { GetSavedCreditCardsModel } from "@NA/Services/SavedCreditCardsService";

const initialState: ADICreditCardListState = {
    isLoading:false,
    creditCardDetails: null
};

const reducer = {
    "Custom/BeginLoadCreditCardListRecap": (draft: Draft<ADICreditCardListState>, action: { result: ADICreditCardListState }) => {
        draft.isLoading = true;
    },
    "Custom/CompleteLoadCreditCardListRecap": (
        draft: Draft<ADICreditCardListState>,
        action: {creditCardResult: GetSavedCreditCardsModel}, 
    ) => {

        draft.isLoading = false;
        draft.creditCardDetails= action.creditCardResult;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
